export const AVAILABILITY_AUTO_REPLY = 'AVAILABILITY_AUTO_REPLY';